import { render } from "./icon-progress.vue?vue&type=template&id=4ba2a99c"
const script = {}

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__